import {
    LoggerResponse,
} from '../Loggers.types'

export enum UpdateField {
    RentingCompany = 'RentingCompany',
    LoggerStatus = 'LoggerStatus',
    DestinationLocation = 'DestinationLocation',
}

export type LoggerBulkUploadFormValues = LoggerResponse & {
    update: UpdateField;
    updateTo: any
}
